/*
* Report page
*/

import * as KendoCharts from '@progress/kendo-react-charts';
import * as React from 'react';
import * as _ from 'lodash';

import * as ReportCharts from '../../charts';
import * as ReportComponents from '../report-components';

export const Render = ({ registerFunc, refFunc, scrollToFunc, appText, pageTitle = '', className = '', pageConfiguration, pageCount, reportData, ...rest }) => {
    const sectionName = ReportComponents.ReportSectionNames.percentFundedGraph;
    const ReportPageWithRegister = ReportComponents.withPageRegistration(ReportComponents.ReportPageHeaderFooter, sectionName, registerFunc, refFunc, scrollToFunc);

    const { formData, association, calculations, isHypothetical, inventory, currentOrder, currentOrderChart, percentFunded, yearlySummaryData } = reportData;

    const mrcOptions = {
        showCurrent: _.get(formData, 'showCurrent', false),
        showMinimum: _.get(formData, 'showMinimum', false),
    };

    // PERCENT FUNDED CHART
    const chartData = ReportCharts.getPCTFundedChartData((e) => appText(e), calculations, isHypothetical, mrcOptions);
    // const chartData = ReportCharts.getPCTFundedChartDataHypPctFunded((e) => appText(e), calculations, isHypothetical, mrcOptions);
    const visibleFundingValues = _.flatten(chartData.filter((item) => item.visible).map((item) => item.data));
    const maxFundingValue = _.max(visibleFundingValues.filter((value) => typeof value === 'number' && isFinite(value))) || 0;
    const maxFundingAxisValue = Math.max(120, (Math.floor(maxFundingValue / 20) + 1) * 20);
    const chartCategories = ReportCharts.getChartCategoriesYearDates(formData.beginYear, formData.calculateYears);
    const chartColors = ReportCharts.getBrandedChartColors();
    const chartAxisTitleFontConfig = 'bold 20px Arial, sans-serif';
    const chartAxisLabelFontConfig = '12px Arial, sans-serif';
    const chartLegendLabelColorConfig = 'color: #000000';

    // console.log('percent-funded-graph', {
    //     chartData: chartData,
    //     formData: formData,
    //     yearlySummaryData: yearlySummaryData,
    //     calculations: calculations,
    // });

    const pfChart = (
        <KendoCharts.Chart renderAs={pageConfiguration.kendoCharts.renderAs}>
            <KendoCharts.ChartArea height={800} />
            <KendoCharts.ChartTitle text="" />
            <KendoCharts.ChartLegend
                labels={{ font: chartAxisLabelFontConfig, padding: 10, color: chartLegendLabelColorConfig }}
                position="bottom"
                orientation="horizontal"
            />
            <KendoCharts.ChartSeries>
                {
                    chartData.map((item, idx) => (
                        <KendoCharts.ChartSeriesItem
                            color={chartColors[idx]}
                            key={`percent-funded-chart-series-${idx}`}
                            markers={{
                                size: 8,
                                background: chartColors[idx],
                                type: _.get(['square', 'circle', 'triangle'], `[${idx}]`, 0)
                            }}
                            type="line"
                            data={item.data}
                            name={item.name}
                            visible={item.visible}
                            visibleInLegend={item.visible}
                            style="smooth"
                            overlay={{ gradient: 'glass' }}
                        />
                    ))
                }
            </KendoCharts.ChartSeries>

            <KendoCharts.ChartValueAxis>
                <KendoCharts.ChartValueAxisItem
                    line={{ color: '#000000', width: 2 }}
                    majorGridLines={{ color: '#c5c5c5', width: 2 }}
                    title={{ text: '% Level of Funding', font: chartAxisTitleFontConfig, color: chartLegendLabelColorConfig }}
                    labels={{ format: '0\'%\'', font: chartAxisLabelFontConfig, color: chartLegendLabelColorConfig }}
                    min={0}
                    max={maxFundingAxisValue}
                />
            </KendoCharts.ChartValueAxis>

            <KendoCharts.ChartCategoryAxis>
                <KendoCharts.ChartCategoryAxisItem
                    name="year"
                    categories={chartCategories}
                    baseUnit="years"
                    baseUnitStep={1}
                    maxDivisions={16}
                    type="date"
                    majorGridLines={{ width: 0 }}
                    line={{ color: '#000000', width: 2 }}
                >
                    <KendoCharts.ChartCategoryAxisTitle text="Year" font={chartAxisTitleFontConfig} color={chartLegendLabelColorConfig} />
                    <KendoCharts.ChartCategoryAxisLabels font={chartAxisLabelFontConfig} color={chartLegendLabelColorConfig} />
                </KendoCharts.ChartCategoryAxisItem>
            </KendoCharts.ChartCategoryAxis>
        </KendoCharts.Chart>
    );

    const page = (
        <ReportPageWithRegister
            title={pageTitle}
            className={className}
            totalPageCount={pageCount}
            showFooter={true}
            footerData={reportData}
        >
            <div className="pdf-page-chart">
                {pfChart}
            </div>
        </ReportPageWithRegister>
    );

    return (
        <div>
            {page}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-percent-funded-graph-kendo.tsx